import { useMemo, useState } from "react";
import { FieldValues, UseFormReturn } from "react-hook-form";
import styled from "styled-components";
import { z } from "zod";
import { Button } from "../../atoms/Button";
import { Input } from "../../atoms/Input";
import FormTemplate from "../../templates/FormTemplate";

type Props = {
  handleSubmit: (code: string) => void;
};

export const CouponCodeForm: React.FC<Props> = ({ handleSubmit }) => {
  const schema = useMemo(() => {
    return z.object({
      code: z.string().min(5),
    });
  }, []);

  const [methods, setMethods] = useState<UseFormReturn<
    FieldValues,
    any,
    undefined
  > | null>(null);

  return (
    <FormTemplate
      schema={schema}
      setMethods={setMethods}
      defaultValues={{ code: "" }}
      onSubmit={({ code }) => {
        handleSubmit(code);
        methods?.reset();
      }}
    >
      <CouponCodeFormContainer>
        <ContentWrapper>
          <Input name="code" type="text" placeholder="例：23qwrtyy" />
        </ContentWrapper>

        <ButtonWrapper>
          <Button
            btnStyle="secondary"
            text="適用"
            type="submit"
            size="sm"
            rounded="md"
          />
        </ButtonWrapper>
      </CouponCodeFormContainer>
    </FormTemplate>
  );
};

const CouponCodeFormContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0;
`;

const ContentWrapper = styled.div`
  flex: 1;
  input {
    line-height: 1.4em;
    font-size: 20px;
    font-weight: 400;
  }
`;

const ButtonWrapper = styled.div`
  button {
    padding: 0px 20px;
    width: auto;
    margin-left: 20px;
    line-height: 1;
    height: 58px;
  }
`;
